import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { findRecord } from '@warp-drive/utilities/json-api';
import { loadTasApplicationHistory } from 'tio-data/requests/tas-application-actions';
import type RouterService from '@ember/routing/router-service';
import type SessionContextService from 'tio-employee/services/session-context';
import type { Store } from '@warp-drive/core';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';

export default class AuthenticatedAdminTuitionAssistanceApplicationsShowRoute extends Route {
  @service declare store: Store;
  @service declare sessionContext: SessionContextService;
  @service declare router: RouterService;

  includes = [
    'tas-courses.tas-assets.attachments',
    'tas-program-instance.tas-program-template.tas-groups',
    'tas-program-instance.tas-program-template.tas-field-options',
    'tas-program-instance.tas-program-template.conditions.public-assets',
    'tas-program-instance.tas-program-template.company.company-setting',
    'tas-program-instance.employee.company.comments',
    'tas-program-instance.employee.person',
    'tas-program-instance.employee.tas-participant',
    'comments.person',
    'tas-assets.attachments',
    'tas-program-instance.tas-assets.attachments',
    'tas-assistances',
    'tags',
    'tas-program-limit',
  ];

  async beforeModel() {
    if (!this.sessionContext.user?.canEditTasApplication) {
      this.router.transitionTo('authenticated.admin.tuition-assistance.applications.show.readonly');
    }
  }

  async model(params: { tas_application_id: string }) {
    const { tas_application_id } = params;

    const { content } = (await this.store.request(
      findRecord<TasApplicationModel>('tas-application', tas_application_id, {
        include: this.includes.join(','),
        reload: true,
      })
    )) as { content: { data: TasApplicationModel } };
    const application = content.data;
    await loadTasApplicationHistory(this.store, application);
    return application;
  }
}
